module.exports = __webpack_public_path__ + "static/media/dport.5b5602ab.jpeg";